// Dependency-free theme controller. Persists a light|dark|system choice and
// toggles the `dark` class on <html>; resolves `system` via the OS preference
// and live-follows it. Used by the useTheme hook + the boot init in index.js.
const STORAGE_KEY = "theme";
const VALID = ["light", "dark", "system"];

const prefersDark = () => {
  try {
    return window.matchMedia("(prefers-color-scheme: dark)").matches;
  } catch {
    return false;
  }
};

export function getStoredTheme() {
  try {
    const v = localStorage.getItem(STORAGE_KEY);
    return VALID.includes(v) ? v : "system";
  } catch {
    return "system";
  }
}

export function resolveTheme(choice = getStoredTheme()) {
  if (choice === "system") return prefersDark() ? "dark" : "light";
  return choice === "dark" ? "dark" : "light";
}

export function applyTheme(resolved = resolveTheme()) {
  const root = document.documentElement;
  if (resolved === "dark") root.classList.add("dark");
  else root.classList.remove("dark");
}

const listeners = new Set();
export function subscribe(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}
function notify() {
  listeners.forEach((fn) => fn());
}

export function setTheme(choice) {
  const next = VALID.includes(choice) ? choice : "system";
  try {
    localStorage.setItem(STORAGE_KEY, next);
  } catch {
    /* ignore */
  }
  applyTheme(resolveTheme(next));
  notify();
}

let systemListenerBound = false;
export function initSystemListener() {
  if (systemListenerBound) return;
  systemListenerBound = true;
  try {
    const mql = window.matchMedia("(prefers-color-scheme: dark)");
    mql.addEventListener("change", () => {
      if (getStoredTheme() === "system") {
        applyTheme(resolveTheme("system"));
        notify();
      }
    });
  } catch {
    /* matchMedia unavailable */
  }
}
